import { render } from "./CaseInformation.vue?vue&type=template&id=4bf00110&scoped=true"
import script from "./CaseInformation.vue?vue&type=script&lang=js"
export * from "./CaseInformation.vue?vue&type=script&lang=js"

import "./CaseInformation.vue?vue&type=style&index=0&id=4bf00110&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf00110"],['__file',"src/components/cases/CaseInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bf00110"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bf00110', __exports__)) {
    console.log('reload')
    api.reload('4bf00110', __exports__)
  }
  
  module.hot.accept("./CaseInformation.vue?vue&type=template&id=4bf00110&scoped=true", () => {
    console.log('re-render')
    api.rerender('4bf00110', render)
  })

}


export default __exports__